export default {
    mate:{},
    actcon: 0,
    isPc: null
}